import { ControlType } from "../controltype";
import { DropDownControl, DropDownListControlConvert } from "./dropdownlist/dropdowncontrol";
import { TextControl } from "./text/textcontrol";
import { SearchControl } from './search/searchcontrol';


import { DateRangeControl } from "./datarange/daterangecontrol";
import { DateControl } from "./date/datecontrol";
import { HelpContol } from "./help/helpcontrol";
import { NumberRangeControl } from "./numberrange/numberrangecontrol";
import { CompareType } from '../comparetype';
import { ComboLookUpControl } from "./combolookup/combolookupcontrol";

/**
 * 控件接口
 */
export interface IControl {

    /**
     * 获取控件类型
     */
    getControlType(): ControlType;

    /**
     * 是否是展示在扩展区域内的
     */
    isExtend: boolean;
    /**是否必填 */
    required: boolean;
    /**日期需要增加类型比较 */
    compareType?: CompareType;
    enableClear?: boolean;
}

export class ControlConvert {
    convertJObject(obj: IControl): Object {
        let control = obj as IControl;
        let controlType = control.getControlType();
        let jobj = new Object();
        jobj["Type"] = controlType;
        if (controlType != ControlType.DropDown) {
            jobj["Content"] = control;
        }
        else {
            let convertor = new DropDownListControlConvert();
            jobj["Content"] = convertor.convertToObject(control as DropDownControl);
        }
        return jobj;
    }

    initFromJobject(jobj: Object): IControl {
        let controlType = jobj["Type"] as ControlType;
        let content: IControl = jobj["Content"];
        if (controlType == ControlType.Text) {
            return Object.assign(new TextControl(), content as TextControl);
        }
        else if (controlType == ControlType.Search) {
            return Object.assign(new SearchControl(), content as SearchControl);
        }
        else if (controlType == ControlType.DateRange) {
            return Object.assign(new DateRangeControl(), content as DateRangeControl);
        }
        else if (controlType == ControlType.NumberRange) {
            return Object.assign(new NumberRangeControl(), content as NumberRangeControl);
        }
        // else if(controlType==ControlType.DateTime){
        //     return Object.assign(new DateControl(),content as DateControl);
        // }
        else if (controlType == ControlType.DropDown) {
            let convert = new DropDownListControlConvert();
            return convert.initFromObject(content);
        }
        else if (controlType == ControlType.Help) {
            return Object.assign(new HelpContol(), content as HelpContol);
        } else if (controlType == ControlType.ComboLookUp) {
            return Object.assign(new ComboLookUpControl(), content as ComboLookUpControl);
        }
    }
}